exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-wrapper>div[data-v-48f039c1]{display:inline-block}p[data-v-48f039c1]{padding:11.5px 15px;margin-top:20px;border:1px solid transparent;font-weight:600;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}p svg[data-v-48f039c1]{width:19px;height:19px;margin-right:10px}p.good[data-v-48f039c1]{background:#e9f3e2;border-color:#c1d8b1;color:#3a631c}p.good svg[data-v-48f039c1]{fill:#3a631c}p.bad[data-v-48f039c1]{background:#f3e2e2;margin-top:20px;border-color:#d8b6b6;color:#992929}p.bad svg[data-v-48f039c1]{fill:#820d2a}.cms-grid[data-v-48f039c1]{margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48f039c1","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/CMSSettings.vue
// module id = tSkK
// module chunks = 0 1